import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend
} from 'recharts';
import './StatsChart.css';

/**
 * Composant graphique d'évolution des statistiques
 * @param {Array} data - Données du graphique [{date, impressions, clicks}, ...]
 * @param {string} title - Titre du graphique
 */
function StatsChart({ data = [], title = 'Évolution' }) {
    // Formater les dates pour l'affichage
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const options = { weekday: 'short', day: 'numeric' };
        return date.toLocaleDateString('fr-FR', options);
    };

    // Formater les tooltips
    const formatTooltipDate = (dateStr) => {
        const date = new Date(dateStr);
        const options = { weekday: 'long', day: 'numeric', month: 'long' };
        return date.toLocaleDateString('fr-FR', options);
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="chart-tooltip">
                    <p className="tooltip-date">{formatTooltipDate(label)}</p>
                    {payload.map((entry, index) => (
                        <p key={index} className="tooltip-item" style={{ color: entry.color }}>
                            {entry.name}: <strong>{entry.value.toLocaleString('fr-FR')}</strong>
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    // Préparer les données avec les dates formatées
    const chartData = data.map(item => ({
        ...item,
        displayDate: formatDate(item.date)
    }));

    if (!data || data.length === 0) {
        return (
            <div className="stats-chart empty">
                <p>Aucune donnée disponible pour cette période</p>
            </div>
        );
    }

    return (
        <div className="stats-chart">
            {title && <h3 className="chart-title">{title}</h3>}
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis
                        dataKey="displayDate"
                        tick={{ fontSize: 12, fill: '#6b7280' }}
                        tickLine={false}
                        axisLine={{ stroke: '#e5e7eb' }}
                    />
                    <YAxis
                        tick={{ fontSize: 12, fill: '#6b7280' }}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={(value) => value.toLocaleString('fr-FR')}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        verticalAlign="top"
                        height={36}
                        formatter={(value) => <span style={{ color: '#374151', fontSize: 13 }}>{value}</span>}
                    />
                    <Line
                        type="monotone"
                        dataKey="impressions"
                        name="Impressions"
                        stroke="#6366f1"
                        strokeWidth={2}
                        dot={{ fill: '#6366f1', strokeWidth: 0, r: 4 }}
                        activeDot={{ r: 6, fill: '#6366f1' }}
                    />
                    <Line
                        type="monotone"
                        dataKey="clicks"
                        name="Clics"
                        stroke="#10b981"
                        strokeWidth={2}
                        dot={{ fill: '#10b981', strokeWidth: 0, r: 4 }}
                        activeDot={{ r: 6, fill: '#10b981' }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default StatsChart;
